import apiList from './web.js'
import vue from '../../src/main.js'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
import elementUI from 'element-ui';
import {
    Loading
} from 'element-ui';

let addUkeyApply = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.addUkeyApply))
    })
}
let getUkeyList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getUkeyList))
    })
}

let getUdunPrice = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getUdunPrice))
    })
}
//
let delSignatureInfoById = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.delSignatureInfoById))
    })
}

let uptSignatureInfoPwdById = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.uptSignatureInfoPwdById))
    })
}

let getCompanyFormKey = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getCompanyFormKey))
    })
}
let getMyCertList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getMyCertList))
    })
}
let updateTitle = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.updateTitle))
    })
}
let getPaytime = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getPaytime))
    })
}
let visitorUpload = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.visitorUpload))
    })
}
let getStampOrSignatureList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getStampOrSignatureList))
    })
}
let checkSealPwd = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.checkSealPwd))
    })
}
let wxPay = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.wxPay))
    })
}
let aliPay = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.aliPay))
    })
}
let cancelOrder = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.cancelOrder))
    })
}
let delStampInfo = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.delStampInfo))
    })
}
let delTemplate = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.delTemplate))
    })
}
let getPageSize = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getPageSize))
    })
}
let getCompanyInfo = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getCompanyInfo))
    })
}
let checkContact = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.checkContact))
    })
}
let getContactCheckList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getContactCheckList))
    })
}
let getAdvertList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getAdvertList))
    })
}
let sealPdfContact = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.sealPdfContact))
    })
}
let calPdfHash = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.calPdfHash))
    })
}
let VerifyCode = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.VerifyCode))
    })
}
let delContactInfo = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.delContactInfo))
    })
}
let registText = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.registText))
    })
}
let sealContact = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.sealContact))
    })
}
let getNewsList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getNewsList))
    })
}
let getNews = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getNews))
    })
}
let getdetailsAndBeforNext = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getdetailsAndBeforNext))
    })
}
let getNewsListById = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getNewsListById))
    })
}
let getNewsMouleList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getNewsMouleList))
    })
}
let updateContact = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.updateContact))
    })
}
let getOrderList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getOrderList))
    })
}
let addOrderInfo = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.addOrderInfo))
    })
}
let getCertList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getCertList))
    })
}
let getMemberInfo = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getMemberInfo))
    })
}
let getStatistics = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getStatistics))
    })
}
let getContactDetails = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getContactDetails))
    })
}
let companyAuthor = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.companyAuthor))
    })
}
let memberAuthor = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.memberAuthor))
    })
}
let cancelMember = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.cancelMember))
    })
}
let checkIdCardEnd = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.checkIdCardEnd))
    })
}
let logout = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.logout))
    })
}
let getStampList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getStampList))
    })
}
let saveStampInfo = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.saveStampInfo))
    })
}
let sendContact = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.sendContact))
    })
}
let getMakeSale = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getMakeSale))
    })
}
let upload = (params) => {//'http://47.108.75.235:5389/'
    return new Promise((resolve, reject) => {
        resolve(postImg(params, apiList.apiList.upload))
    })
}
let getContactList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getContactList))
    })
}
let addContactInfo = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.addContactInfo))
    })
}
let getTemplateDetails = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getTemplateDetails))
    })
}
let getTemplateList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getTemplateList))
    })
}
let addTemplateInfo = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.addTemplateInfo))
    })
}

let emailCodeLogin = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.emailCodeLogin))
    })
}
let sendCodeToEmail = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.sendCodeToEmail))
    })
}
let updatePassword = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.updatePassword))
    })
}
let forgetAndUpdatePassword = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.forgetAndUpdatePassword))
    })
}
let phoneCodeLogin = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.phoneCodeLogin))
    })
}
let register = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.register))
    })
}
let clientLogin = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.clientLogin))
    })
}

let sendCodeToPhone = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.sendCodeToPhone))
    })
}



let createContactByPdf = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.createContactByPdf))
    })
}

let updateContactByPdf = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.updateContactByPdf))
    })
}


let getSealNameList = (params) => {
    return new Promise((resolve, reject) => {
        resolve(postNo(params, apiList.apiList.getSealNameList))
    })
}



function get(params, url) {
    return new Promise(function (resolve, reject) {
        axios({
            method: "get",
            url: url,
            data: params,
        }).then(function (result) {
            console.log(result)
            try {
                if (result.data.code == 0) {
                    elementUI.MessageBox(result.data.data, '提示', {
                        confirmButtonText: '确定',
                        callback: action => {

                        }
                    });
                } else {
                    resolve(result.data.data);
                }
            } catch (e) {
                console.log(e)
                elementUI.MessageBox('服务器炸了', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                });
            }

        }).catch(function (err) {
            console.log(err)
            elementUI.MessageBox('服务器炸了', '提示', {
                confirmButtonText: '确定',
                callback: action => {

                }
            });
        });
    });
}

function postImg(params, url) {
    return new Promise(function (resolve, reject) {
        axios({
            method: "post",
            // contentType: "application/json;charset=UTF-8",
            url: url,
            data: params,
        }).then((res) => {
            console.log(res)
            try {
                resolve(res.data);

            } catch (e) {
                console.log(e)
                elementUI.MessageBox('服务繁忙', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {

                    }
                });
            }
        }).catch(function (err) {
            console.log(err)
            elementUI.MessageBox('服务繁忙', '提示', {
                confirmButtonText: '确定',
                callback: action => {

                }
            });
        });
    });
}

function postNo(params, url) {
    let loading = Loading.service({
        lock: true,
        text: '加载中.....',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        spinner: 'my-el-custom-spinner',
    });
    return new Promise(function (resolve, reject) {
        axios({
            method: "post",
            // contentType: "application/json;charset=UTF-8",
            url: url,
            data: params,
        }).then((res) => {
            console.log(res)
            try {
                loading.close()
                if (res.data.code == 0) {// || res.data.code == 1
                    var storage = window.localStorage;

                    resolve(res.data);
                } else {
                    elementUI.Message.error(res.data.msg);
                    reject(res.data.code)
                    if (res.data.msg == '请重新登录') {
                        var storage = window.localStorage;
                        vue.$router.push('/')
                        storage.clear();
                        location.reload();
                    }
                }

            } catch (e) {
                console.log(e)
                loading.close()
                elementUI.Message.error('服务繁忙');
            }
        }).catch(function (err) {
            loading.close()
            console.log(err)
            elementUI.Message.error('服务繁忙');
        });
    });
}

export default {
    get,
    postNo,
    register,
    sendCodeToPhone,
    clientLogin,
    phoneCodeLogin,
    forgetAndUpdatePassword,
    sendCodeToEmail,
    emailCodeLogin,
    addTemplateInfo,
    getTemplateList,
    getTemplateDetails,
    addContactInfo,
    getContactList,
    upload,
    sendContact,
    saveStampInfo,
    getStampList,
    updatePassword,
    logout,
    checkIdCardEnd,
    getMakeSale,
    cancelMember,
    memberAuthor,
    companyAuthor,
    getContactDetails,
    getStatistics,
    getMemberInfo,
    getCertList,
    addOrderInfo,
    getOrderList,
    updateContact,
    getNewsMouleList,
    getNewsListById,
    getdetailsAndBeforNext,
    getNews,
    getNewsList,
    sealContact,
    registText,
    delContactInfo,
    VerifyCode,
    calPdfHash,
    sealPdfContact,
    getAdvertList,
    getContactCheckList,
    checkContact,
    getCompanyInfo,
    delTemplate,
    getPageSize,
    delStampInfo,
    cancelOrder,
    aliPay,
    wxPay,
    checkSealPwd,
    getStampOrSignatureList,
    visitorUpload,
    getPaytime,
    updateTitle,
    getMyCertList,
    getCompanyFormKey,
    delSignatureInfoById,
    getUdunPrice,
    addUkeyApply,
    getUkeyList,
    createContactByPdf,
    updateContactByPdf,
    getSealNameList,
    uptSignatureInfoPwdById,

}



//////////////////
// WEBPACK FOOTER
// ./static/js/https.js
// module id = null
// module chunks = 